import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import ContentPage from '../components/ContentPage';

const AcademyContentTemplate = ({
  data: { relatedContent },
  pageContext,
  ...props
}) => (
  <React.Fragment>
    <Helmet>
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "headline": "${pageContext.page.title}",
            ${
              pageContext.page.coverImage &&
              `"image": "${pageContext.page.coverImage.url}"`
            }
          }
        `}
      </script>
    </Helmet>
    <ContentPage
      relatedContent={relatedContent.nodes}
      {...pageContext}
      {...props}
    />
  </React.Fragment>
);

export const query = graphql`
  query relatedAcademyContent($id: String!) {
    relatedContent: allGraphCmsAcademyPost(
      filter: { id: { ne: $id } }
      limit: 2
    ) {
      nodes {
        id
        slug
        friendlySlug
        title
        subTitle
        coverImage {
          id
          url
          handle
          width
          height
        }
        authors {
          name
          title
          twitterHandle
          photo {
            id
            url
            handle
            width
            height
          }
        }
        content
        externalUrl
        linkPath
      }
    }
  }
`;

export default AcademyContentTemplate;
